import { lazyLoad } from 'utils/loadable';
import { Navigate } from 'react-router-dom';
import { activeDataConfigRoutes } from './activeDataConfigRoutes';

const ActiveDataPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ActiveDataPage', webpackPrefetch: true */ './index'
  ),
);

const IntroPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'IntroPage', webpackPrefetch: true */ './components/ActiveDataIntro'
  ),
);

const ProductsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ProductsPage', webpackPrefetch: true */ './components/Products'
  ),
);
const ServicesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ServicesPage', webpackPrefetch: true */ './components/Services'
  ),
);

const TeamPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TeamPage', webpackPrefetch: true */ './components/Teams'
  ),
);

const PortfoliosPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PortfoliosPage', webpackPrefetch: true */ './components/Portfolios'
  ),
);

const TestimonialsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PortfoliosPage', webpackPrefetch: true */ './components/Testimonial'
  ),
);

const ContactPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ContactPage', webpackPrefetch: true */ './components/Contacts'
  ),
);

// const EventsPage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'EventsPage', webpackPrefetch: true */ './components/Events'
//   ),
// );

export const activeDataMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        {
          component: IntroPage,
          path: '/introduction',
        },
        {
          component: ProductsPage,
          title: 'Products',
          path: activeDataConfigRoutes.PRODUCTS,
        },
        {
          component: ServicesPage,
          title: 'Services',
          path: activeDataConfigRoutes.SERVICES,
        },
        {
          component: TeamPage,
          title: 'Teams',
          path: activeDataConfigRoutes.TEAMS,
        },
        {
          component: PortfoliosPage,
          title: 'Portfolios',
          path: activeDataConfigRoutes.PORTFOLIOS,
        },
        {
          component: TestimonialsPage,
          title: 'Testimonials',
          path: activeDataConfigRoutes.TESTIMONIALS,
        },
        {
          component: ContactPage,
          title: 'Contacts',
          path: activeDataConfigRoutes.CONTACTS,
        },
        // {
        //   component: EventsPage,
        //   title: 'Testimonials',
        //   path: activeDataConfigRoutes.EVENTS,
        // },
      ]
    : []),
];

// routes declaration
export const activeDataRoutes = [
  {
    component: Navigate,
    path: '/active-data',

    replace: true,
    to: '/active-data' + activeDataConfigRoutes.DEFAULT,
    toAdmin: '/active-data' + activeDataConfigRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: ActiveDataPage,
    title: 'Ai-Agent',
    path: '/active-data/*',
    needsAuth: true,
  },
];
